/**
 * Normalizes user data from API / localStorage (object or JSON string).
 */
export function parseStoredUser(value) {
  if (!value) return null;
  if (typeof value === "object") return value;
  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) {
    return { fullName: trimmed };
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    return { fullName: trimmed };
  }
}

export function getUserDisplayName(user) {
  const profile = parseStoredUser(user);
  if (!profile) return null;

  return (
    profile.fullName ||
    profile.FullName ||
    profile.userName ||
    profile.UserName ||
    profile.username ||
    profile.Username ||
    null
  );
}

export function getUserRoleLabel(user) {
  const profile = parseStoredUser(user);
  const role = profile?.role || profile?.Role;
  if (!role) return "Operations · Admin";
  return `Operations · ${role}`;
}

export function getUserInitial(user) {
  const name = getUserDisplayName(user);
  return name ? name.charAt(0).toUpperCase() : "?";
}
